"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var lodash_camelcase_1 = __importDefault(require("lodash.camelcase"));
var context_1 = require("./context");
var initLDClient_1 = __importDefault(require("./initLDClient"));
var utils_1 = require("./utils");
/**
 * withLDProvider is a function which accepts a config object which is used to initialise launchdarkly-js-client-sdk.
 * It returns a function which accepts your root React component and returns a HOC.
 * This HOC does three things:
 * - It initializes the ldClient instance by calling launchdarkly-js-client-sdk initialize on componentDidMount
 * - It saves all flags and the ldClient instance in the context api
 * - It subscribes to flag changes and propagate them through the context api
 *
 * @param config - The configuration used to initialize LaunchDarkly's js client
 */
function withLDProvider(config) {
    return function withLDPoviderHoc(WrappedComponent) {
        return /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1(props) {
                var _this = _super.call(this, props) || this;
                _this.subscribeToChanges = function (ldClient) {
                    ldClient.on('change', function (changes) {
                        var flattened = {};
                        for (var key in changes) {
                            flattened[lodash_camelcase_1.default(key)] = changes[key].current;
                        }
                        _this.setState(function (_a) {
                            var flags = _a.flags;
                            return ({ flags: __assign({}, flags, flattened) });
                        });
                    });
                };
                _this.state = {
                    flags: {},
                    ldClient: undefined,
                };
                var options = config.options;
                if (options) {
                    var bootstrap = options.bootstrap;
                    if (bootstrap && bootstrap !== 'localStorage') {
                        _this.state = {
                            flags: utils_1.camelCaseKeys(bootstrap),
                            ldClient: undefined,
                        };
                    }
                }
                return _this;
            }
            class_1.prototype.componentDidMount = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var clientSideID, user, options, flags, _a, fetchedFlags, ldClient;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                clientSideID = config.clientSideID, user = config.user, options = config.options, flags = config.flags;
                                return [4 /*yield*/, initLDClient_1.default(clientSideID, user, options, flags)];
                            case 1:
                                _a = _b.sent(), fetchedFlags = _a.flags, ldClient = _a.ldClient;
                                this.setState({ flags: fetchedFlags, ldClient: ldClient });
                                this.subscribeToChanges(ldClient);
                                return [2 /*return*/];
                        }
                    });
                });
            };
            class_1.prototype.render = function () {
                return (React.createElement(context_1.Provider, { value: this.state },
                    React.createElement(WrappedComponent, __assign({}, this.props))));
            };
            return class_1;
        }(React.Component));
    };
}
exports.withLDProvider = withLDProvider;
exports.default = withLDProvider;
//# sourceMappingURL=withLDProvider.js.map